import React, { useState, useEffect } from 'react';
import { Card, Avatar, Button, Typography, Form, Input, Modal, Tag, Space } from 'antd';
import { UserOutlined } from '@ant-design/icons';
import AppHeader from '../../components/Header';
import AppFooter from '../../components/Footer';
import './index.css';

const { Title, Text } = Typography;

const ProfilePage = () => {
  const [userInfo, setUserInfo] = useState({
    name: 'lyh',
    avatar: 'https://via.placeholder.com/150',
    bio: '这个人很神秘，什么也没留下。',
    description: '欢迎来到我的博客！请登陆后完善您的个人信息！',
    email: 'lyh@gmail.com',
    techStack: 'React, JavaScript, Node.js',
    hobbies: '编程, 旅行, 摄影',
    github: 'https://github.com/lyh',
    homepage: 'https://lyh.com'
  });

  const [isEditing, setIsEditing] = useState(false);

  const [form] = Form.useForm();

  useEffect(() => {
    const storedUserInfo = JSON.parse(localStorage.getItem('userInfo'));
    if (storedUserInfo) {
      setUserInfo(storedUserInfo);
    }
  }, []);

  const saveUserInfo = (values) => {
    const updatedUserInfo = { ...userInfo, ...values };
    setUserInfo(updatedUserInfo);
    localStorage.setItem('userInfo', JSON.stringify(updatedUserInfo));
  };

  const handleEditClick = () => {
    form.setFieldsValue(userInfo);
    setIsEditing(true);
  };

  const handleCancel = () => {
    setIsEditing(false);
  };

  const handleSubmit = (values) => {
    saveUserInfo(values);
    setIsEditing(false);
  };

  return (
    <div style={{ padding: '20px', backgroundColor: '#f5f5f5', minHeight: '100vh' }}>
      <AppHeader />
      <Card
        style={{
          width: '80%',
          maxWidth: '800px',
          margin: '20px auto',
          borderRadius: '12px',
          boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
          backgroundColor: '#ffffff',
        }}
      >
        <div style={{ textAlign: 'center', marginBottom: '20px' }}>
          <Avatar
            size={100}
            src={userInfo.avatar}
            icon={<UserOutlined />}
            style={{ marginBottom: '10px' }}
          />
          <Title level={2} style={{ margin: '0' }}>
            Hi，我是 {userInfo.name}!
          </Title>
          <Text type="secondary" style={{ display: 'block', marginTop: '10px' }}>
            {userInfo.bio}
          </Text>
          <Text type="secondary" style={{ display: 'block', marginTop: '10px' }}>
            {userInfo.description}
          </Text>
        </div>

        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '20px' }}>
          <div style={{ flex: 1, minWidth: '250px' }}>
            <div style={{ marginBottom: '15px' }}>
              <Text strong>邮箱</Text>
              <Text type="secondary" style={{ marginLeft: '10px' }}>
                {userInfo.email}
              </Text>
            </div>
            
            <div style={{ marginBottom: '15px' }}>
              <Text strong>技术栈</Text>
              <div style={{ marginLeft: '10px', marginTop: '5px' }}>
                <Space wrap>
                  {userInfo.techStack.split(',').map((tech, index) => (
                    <Tag key={index} color="blue">
                      {tech.trim()}
                    </Tag>
                  ))}
                </Space>
              </div>
            </div>
            
            <div style={{ marginBottom: '15px' }}>
              <Text strong>兴趣爱好</Text>
              <div style={{ marginLeft: '10px', marginTop: '5px' }}>
                <Space wrap>
                  {userInfo.hobbies.split(',').map((hobby, index) => (
                    <Tag key={index} color="green">
                      {hobby.trim()}
                    </Tag>
                  ))}
                </Space>
              </div>
            </div>
          </div>

          <div style={{ flex: 1, minWidth: '250px' }}>
            <div style={{ marginBottom: '15px' }}>
              <Text strong>GitHub</Text>
              <Text type="secondary" style={{ marginLeft: '10px' }}>
                <a href={userInfo.github} target="_blank" rel="noopener noreferrer">
                  {userInfo.github}
                </a>
              </Text>
            </div>
            
            <div style={{ marginBottom: '15px' }}>
              <Text strong>个人主页</Text>
              <Text type="secondary" style={{ marginLeft: '10px' }}>
                <a href={userInfo.homepage} target="_blank" rel="noopener noreferrer">
                  {userInfo.homepage}
                </a>
              </Text>
            </div>
          </div>
        </div>

        <div style={{ textAlign: 'center', marginTop: '20px' }}>
          <Button type="primary" onClick={handleEditClick}>
            编辑个人信息
          </Button>
        </div>

        <Modal
          title="编辑个人信息"
          open={isEditing}
          onCancel={handleCancel}
          onOk={() => form.submit()}
          width={600}
          footer={[
            <Button key="cancel" onClick={handleCancel}>
              取消
            </Button>,
            <Button key="submit" type="primary" onClick={() => form.submit()}>
              保存
            </Button>,
          ]}
        >
          <Form
            form={form}
            layout="vertical"
            onFinish={handleSubmit}
          >
            <Form.Item
              name="avatar"
              label="头像 URL"
              rules={[{ required: true, message: '请输入头像 URL' }]}
            >
              <Input placeholder="请输入头像图片链接" />
            </Form.Item>

            <Form.Item
              name="name"
              label="姓名"
              rules={[{ required: true, message: '请输入姓名' }]}
            >
              <Input placeholder="请输入姓名" />
            </Form.Item>

            <Form.Item
              name="bio"
              label="个人简介"
              rules={[{ required: true, message: '请输入个人简介' }]}
            >
              <Input.TextArea 
                rows={2} 
                placeholder="请输入个人简介" 
                maxLength={100}
                showCount
              />
            </Form.Item>

            <Form.Item
              name="description"
              label="详细描述"
              rules={[{ required: true, message: '请输入详细描述' }]}
            >
              <Input.TextArea 
                rows={3} 
                placeholder="请输入详细描述" 
                maxLength={300}
                showCount
              />
            </Form.Item>

            <Form.Item
              name="email"
              label="邮箱"
              rules={[
                { required: true, message: '请输入邮箱' },
                { type: 'email', message: '请输入有效的邮箱地址' }
              ]}
            >
              <Input placeholder="请输入邮箱" />
            </Form.Item>

            <Form.Item
              name="techStack"
              label="技术栈"
              extra="请用逗号分隔多个技术栈，如：React, JavaScript, Node.js"
            >
              <Input placeholder="请输入技术栈，用逗号分隔" />
            </Form.Item>

            <Form.Item
              name="hobbies"
              label="兴趣爱好"
              extra="请用逗号分隔多个兴趣爱好，如：编程, 旅行, 摄影"
            >
              <Input placeholder="请输入兴趣爱好，用逗号分隔" />
            </Form.Item>

            <Form.Item
              name="github"
              label="GitHub 链接"
            >
              <Input placeholder="请输入 GitHub 链接" />
            </Form.Item>

            <Form.Item
              name="homepage"
              label="个人主页链接"
            >
              <Input placeholder="请输入个人主页链接" />
            </Form.Item>
          </Form>
        </Modal>
      </Card>
      <AppFooter />
    </div>
  );
};

export default ProfilePage;